module.exports = __webpack_public_path__ + "img/package-gift-blue-sm.a0b33c96.svg";